@if (customViewsAvailable) {
  <button 
    #dropdownBtn
    ejs-dropdownbutton 
    class="custom-view-btn" 
    target="#listview"
    (open)="onDropdownOpen()"
    (created)="initialized = true"
  >
    {{ selectedCustomView?.ViewName ?? 'Select Customview' }}
  </button>
} @else {
  <div class="add-custom-view-link" (created)="initialized = true" (click)="openCustomView($event, 'add')">
    <i class="e-icons e-plus"></i> New Custom View
  </div>
}

@if (customViewsAvailable) {
  <div id="listview" class="listview-layout customview-list" [style]="{ display: initialized ? 'block' : 'none' }">
    @if(this.currentViews.length){
      <!-- Header -->
      <div class="main-section-layout">
        <h2>{{ isSystemViewMode ? 'System View' : 'Quick Access' }}</h2>
      </div>
    }
    
    <!-- Built-in Views (System or Favorite) -->
    @for (view of currentViews; track view.Id) {
      <div 
        class="on-hover-favourite" 
        (click)="selectBuiltInView(view)" 
        [class.selected-favorite]="selectedCustomView?.Id === view.Id"
      >
        <div class="custom-list-layout-favourite">
          <div class="d-flex">
            <div class="custom-fav-count pe-1">
              <p class="data-listing custom-view-list m-0" style="padding-right: 4px">
                {{ view.ViewName }}
              </p>
            </div>
            <!-- Show count only for favorite view -->
            @if (view.Id === FAVORITE_RECORDS_VIEW.Id) {
              <div class="custom-list-action favorite-count">
                <p>{{ favoriteCount }}</p>
              </div>
            }
          </div>
          <div class="custom-list-action">
            <button class="e-dropdown-btn default-icon-show" *ngIf="selectedCustomView?.Id === view.Id">
              <i class="fa fa-anchor"></i>
            </button>
            <button 
              class="e-dropdown-btn" 
              *ngIf="selectedCustomView?.Id !== view.Id && _value.component?.Configuration?.componentValue?.isUserPersonalizationSupported" 
              (click)="markAsDefaultCustomView(view)"
            >
              <i class="fa fa-anchor" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    }
    
    <!-- Custom Views Section (only in legacy mode) -->
    @if (!isSystemViewMode && customViewList?.length) {
      <div class="main-section-layout">
        <h2>Standard View</h2>
      </div>
      
      <ejs-listview #listViewComponent class="custom-option-layout" [dataSource]="customViewList" (select)="onSelect($event)">
        <ng-template #template let-data="">
          <div class="on-hover-tooltip">
            <div class="custom-list-layout e-active">
              <div class="pe-2">
                <p class="data-listing custom-view-list m-0" style="padding-right: 4px">
                  {{ data.ViewName }}
                </p>
              </div>
              <div class="custom-list-action">
                <button class="e-dropdown-btn default-icon-show" *ngIf="selectedCustomView?.Id == data?.Id">
                  <i class="fa fa-anchor"></i>
                </button>
                <button 
                  class="e-dropdown-btn" *ngIf="
                  selectedCustomView?.Id !== data?.Id &&
                  (
                    _value.component?.Configuration?.componentValue?.isUserPersonalizationSupported ||
                    doesHaveAdministratorPermissions()
                  )
                  " (click)="markAsDefaultCustomView(data)"
                >
                  <i class="fa fa-anchor" aria-hidden="true"></i>
                </button>
                <button 
                  class="e-dropdown-btn" *ngIf="
                  sdk.store.userId?.toLowerCase() === data?.RecordInfo?.CreatedBy?.toLowerCase() ||
                  doesHaveAdministratorPermissions()
                  " (click)="openCustomView(data, 'edit')"
                >
                  <i class="fa fa-pen-to-square" aria-hidden="true"></i>
                </button>
                <button 
                  class="e-dropdown-btn" *ngIf="
                  sdk.store.userId?.toLowerCase() === data?.RecordInfo?.CreatedBy?.toLowerCase() ||
                  doesHaveAdministratorPermissions()
                  " (click)="deleteCustomView(data)"
                >
                  <i class="fa fa-trash-can" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </ejs-listview>
    }
    
    <!-- Add Button (only in legacy mode) -->
    @if (!this.isSystemViewMode) {
      <div class="add-custom-view-link" (click)="openCustomView($event, 'add')">
        <i class="e-icons e-plus"></i> New Custom View
      </div>
    }
  </div>
}